// queries/useGetAdminModelImages.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_ADMIN_IMAGE_GENERATIONS } from "api";
import { FetchImagesParams, UseGetAllModelsParams } from "types";

// Function to fetch models
const fetchImages = async ({ queryKey }: { queryKey: [string, FetchImagesParams] }) => {
  const [, { page, pageSize, id }] = queryKey;
  let queryString = `page=${page}&page_size=${pageSize}`;

  return fetch(`${GET_ADMIN_IMAGE_GENERATIONS(id)}?${queryString}`);
};

// React Query Hook
export const useGetAdminModelImages = (params: UseGetAllModelsParams) => {
  return useQuery({
    queryKey: ["modelImagesAdmin", params],
    queryFn: fetchImages,
    staleTime: 5000,
    enabled: !!params.id,
  });
};

export default useGetAdminModelImages;
